import { useState } from "react";

import Header from "../Header";
import Icon from "../Icon";
import { GuestPass } from ".";
import { GuestPassFaq } from "./GuestPassGroupCard";

type FaqItemProps = {
  faqs: GuestPassFaq[];
};

const Faqs = ({ faqs }: FaqItemProps) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    if (openIndex === index) {
      setOpenIndex(null);
    } else {
      setOpenIndex(index);
    }
  };

  return (
    <>
      {faqs.map(({ question, answer }, i) => (
        <div key={i} className="mb-4" onClick={() => toggle(i)}>
          <div className="flex justify-between">
            <h3 className="w-11/12 font-poppins text-lg font-semibold">
              {question}
            </h3>
            <Icon
              className={openIndex === i ? "rotate-90" : "-rotate-90"}
              name="arrow"
            />
          </div>
          {openIndex === i && <p className="mt-4 text-base">{answer}</p>}
        </div>
      ))}
    </>
  );
};

type Props = {
  pass: GuestPass;
};

export default function GuestPassRestrictionsAndFAQs({ pass }: Props) {
  return (
    <>
      {pass.restrictions && (
        <>
          <Header className="mb-4 mt-6 text-[22px] text-white" as="h2">
            Restrictions
          </Header>
          <p className="mb-2 text-base">{pass.restrictions}</p>
        </>
      )}
      {pass.faqs.length > 0 && (
        <div className="mt-4">
          <Header className="mb-4 text-[22px] text-white" as="h2">
            FAQs
          </Header>
          <Faqs faqs={pass.faqs} />
        </div>
      )}
    </>
  );
}
